import { BASE_URL } from "../../data/BaseUrl";

export const fetchTestimonial = async (filters, TOKEN) => {
  let url = `gym/vibe`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchTestimonial=> ", error);
    throw error;
  }
};

export const fetchWorkoutGoal = async (filters, TOKEN) => {
  let url = `workout/goal`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchWorkoutGoal=> ", error);
    throw error;
  }
};

export const fetchPartners = async (filters, TOKEN) => {
  let url = `leads/interested_partner`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchPartners=> ", error);
    throw error;
  }
};

export const fetchGymCities = async (filters, TOKEN) => {
  let url = `gym/cities/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchGymCities=> ", error);
    throw error;
  }
};

export const fetchGymCityLocation = async (filters, TOKEN) => {
  let url = `gym/places/v2?is_web=1`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchGymCityLocation=> ", error);
    throw error;
  }
};

export const fetchTraining = async (filters, TOKEN) => {
  let url = `training?is_web=1`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchTraining=> ", error);
    throw error;
  }
};

export const fetchMetabseLinks = async (filters, TOKEN) => {
  let url = `metabase/all`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchMetabseLinks=> ", error);
    throw error;
  }
};

export const fetchGymLandingPages = async (filters, TOKEN) => {
  let url = `gym/lp/get-url`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchGymLandingPages=> ", error);
    throw error;
  }
};

export const fetchNearestGyms = async (filters, TOKEN) => {
  let url = `gym/nearestgym/new?lat=28.596923663299105&long=77.32872149880232`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchNearestGyms=> ", error);
    throw error;
  }
};

export const fetchGymAlias = async (filters, TOKEN) => {
  let url = `gym/alias`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchGymAlias=> ", error);
    throw error;
  }
};

export const fetchFranchiseLeads = async (filters, TOKEN) => {
  let url = `leads/franchise-leads`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchFranchiseLeads=> ", error);
    throw error;
  }
};

// What's New (ported from main) — admin CMS for in-app announcement cards
export const fetchWhatsNew = async (TOKEN) => {
  let url = `whatNew/getAll`;

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchWhatsNew=> ", error);
    throw error;
  }
};

// Trainers Rating (ported from main) — read-only list of member ratings per trainer
export const fetchTrainerRatings = async (filters, TOKEN) => {
  let url = "ptTrial/rating";
  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  if (filteredParams) {
    url += `?${filteredParams}`;
  }
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainerRatings=> ", error);
    throw error;
  }
};

export const fetchTrainerRatingsStat = async (TOKEN) => {
  // powered route is ptTrial/rating/stats (getRatingStats)
  let url = "ptTrial/rating/stats";
  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchTrainerRatingsStat=> ", error);
    throw error;
  }
};
